// Side-effect module: install polyfills for newer JS APIs missing on older
// Safari/iOS WebKit. Import this first, before any other module, so the
// polyfills are in place before dependent code runs.

// Promise.withResolvers (ES2024) - required for pdfjs-dist on Safari < 17.4
if (typeof Promise.withResolvers !== 'function') {
  Promise.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void
    let reject!: (reason?: unknown) => void
    const promise = new Promise<T>((res, rej) => {
      resolve = res
      reject = rej
    })
    return { promise, resolve, reject }
  }
}

// URL.canParse (ES2024) - required by @braintree/sanitize-url on Safari/iOS < 17
if (typeof URL.canParse !== 'function') {
  URL.canParse = (url: string | URL, base?: string | URL): boolean => {
    try {
      new URL(url, base)
      return true
    } catch {
      return false
    }
  }
}
